import React from "react";
import { IonSkeletonText } from "@ionic/react";

interface ChatBotHistorySkeletonProps {
  itemCount?: number;
}

export const ChatBotHistoryItemSkeleton: React.FC = () => {
  return (
    <div className="px-[20px]">
      <div className="mt-[10px]">
        <div className="pt-[20px]">
          {/* User question skeleton */}
          <div className="w-3/4 h-[24px]">
            <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
          </div>

          {/* Bot response header skeleton */}
          <div className="flex mt-7 gap-[12px] items-center">
            <div className="w-[24px] h-[24px] rounded-full">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "50%", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
            <div className="w-1/3 h-[24px]">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
          </div>

          {/* Bot response content skeleton */}
          <div className="flex-col space-y-[7px] mt-[10px]">
            <div className="w-full h-[16px]">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
            <div className="w-5/6 h-[16px]">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
            <div className="w-4/5 h-[16px]">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
            <div className="w-full h-[16px]">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
          </div>
        </div>

        {/* Like/dislike section skeleton */}
        {/* <div className="mt-8 flex items-center gap-[42px]">
          <div className="w-1/3 h-[20px]">
            <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
          </div>
          <div className="flex items-center gap-2.5">
            <div className="w-[31.2px] h-[31.2px] rounded-[6px]">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "6px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
            <div className="w-[31.2px] h-[31.2px] rounded-[6px]">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "6px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
          </div>
        </div> */}

        {/* Follow-up questions section skeleton */}
        <div className="pt-[25px]">
          <div className="flex mt-5 gap-[10px]">
            <div className="w-[24px] h-[24px] rounded-full">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
            <div className="w-1/3 h-[24px]">
              <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
            </div>
          </div>

          {/* Follow-up questions list skeleton */}
          <div className="flex-col space-y-[7px] mt-[10px]">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex justify-between gap-3 items-center border-b border-white/10 py-3 pr-1">
                <div className="w-4/5 h-[18px]">
                  <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
                </div>
                <div className="w-[20px] h-[20px]">
                  <IonSkeletonText animated style={{ height: "100%", borderRadius: "4px", '--background-rgb': '255, 255, 255', opacity: '1' } as any} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// Container-wise skeleton for the entire chat history
const ChatBotHistorySkeleton: React.FC<ChatBotHistorySkeletonProps> = ({ itemCount = 2 }) => {
  return (
    <div>
      {[...Array(itemCount)].map((_, index) => (
        <ChatBotHistoryItemSkeleton key={index} />
      ))}
    </div>
  );
};

export default ChatBotHistorySkeleton; 